export default class GridTexsEntrantController {
	/* @ngInject */
	constructor($state) {
		this.$state = $state;
	}

	async $onInit() {
		console.log('grid texs entrant initialized');
	}

	redirectToDAP(id) {
		let url = this.$state.href('daps.edit', { id: id });
		window.open('gestion.html' + url);
	}

	redirectToTicket(id) {
		let url = this.$state.href('tickets.detail', { id: id });
		window.open('gestion.html' + url);
	}
}
